module.exports = __webpack_public_path__ + "static/media/ua-min.8e1dc66e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/min/ua-min.svg
// module id = 697
// module chunks = 0